import Bill from "../../../model/bill/Bill";

export const BILLS_FETCHED = "BILLS_FETCHED";
export type BILLS_FETCHED = { bills: Bill[] }

export const BILL_FETCHED = "BILL_FETCHED";
export type BILL_FETCHED = { bill: Bill }

export const BILL_UPDATED = "BILL_UPDATED";
export type BILL_UPDATED = { bill: Bill }
